import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import {
  FORGOT_USERNAME,
  REQUEST_PASSWORD_RESET,
  RESET_PASSWORD
} from '../actions/resetPassword'
import { restReducer } from '../h2Api.js'

export const initialFormState = {
  username: '',
  password: '',
  confirm: ''
}

export const initialUsernameForm = {
  email: ''
}

export const initialPasswordResetForm = {
  username: ''
}

const resetPassword = combineReducers({
  forgotUsernameForm: modelReducer(
    'resetPassword.forgotUsernameForm',
    initialUsernameForm
  ),
  requestPasswordResetForm: modelReducer(
    'resetPassword.requestPasswordResetForm',
    initialPasswordResetForm
  ),
  form: modelReducer('resetPassword.form', initialFormState),
  forms: formReducer('resetPassword', {
    form: initialFormState,
    forgotUsernameForm: initialUsernameForm,
    requestPasswordResetForm: initialPasswordResetForm
  }),
  request: restReducer(RESET_PASSWORD),
  usernameLookupRequest: restReducer(FORGOT_USERNAME),
  passwordResetRequest: restReducer(REQUEST_PASSWORD_RESET)
})

export default resetPassword
